import { createState, Store } from '@ngneat/elf';
import { withActiveId, withEntities } from '@ngneat/elf-entities';
import { inject, Injectable } from '@angular/core';
import { EntityRepository } from '@data/entity-repository';
import { MatchingSession } from '@data/matching-session/matching-session.model';
import { MatchingSessionService } from '@data/matching-session/matching-session.service';
import { withRequestsCache } from '@ngneat/elf-requests';

const { state, config } = createState(
  withEntities<MatchingSession>(),
  withActiveId(),
  withRequestsCache(),
);

const matchingSessionStore = new Store({ name: 'matching-session', state, config });

@Injectable({ providedIn: 'root' })
export class MatchingSessionRepository extends EntityRepository<MatchingSession> {
  protected constructor() {
    const matchingSessionService = inject(MatchingSessionService);

    super(matchingSessionService);
  }

  protected override requireStore(): Store {
    return matchingSessionStore;
  }
}
